export default "__VITE_ASSET__jaGASZRe__"